import { DISABLED_LICENSE_EXPIRATION_DATE } from '../license-helpers';

export const ensureDateIsUTC = (
    dateStr: string | undefined,
    disabledValue: string = DISABLED_LICENSE_EXPIRATION_DATE
): string => {
    if (!dateStr || dateStr === disabledValue) {
        return dateStr || '';
    }
    return dateStr.endsWith('Z') ? dateStr : dateStr + 'Z';
};
